import { useEffect } from 'react';
import { useConsent } from '../context/ConsentContext';

type Props = { metaPixelId?: string; gtagId?: string };

export default function TrackingGate({ metaPixelId, gtagId }: Props) {
  const { consent } = useConsent();

  useEffect(() => {
    if (!consent) return;
    if (consent.analytics && gtagId && !(window as any).gtag) {
      const s1 = document.createElement('script');
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gtagId)}`;
      document.head.appendChild(s1);
      const s2 = document.createElement('script');
      s2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config','${gtagId}',{send_page_view:false});`;
      document.head.appendChild(s2);
    }
    if (consent.marketing && metaPixelId && !(window as any).fbq) {
      const s = document.createElement('script');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${metaPixelId}');fbq('track','PageView');`;
      document.head.appendChild(s);
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1"/>`;
      document.body.appendChild(noscript);
    }
  }, [consent, metaPixelId, gtagId]);

  return null;
}


